import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { pagesApi, type PageListParams } from '../api/pages-api';

import { pageKeys } from './page-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function pageListQueryOptions(storeId: string, params: PageListParams) {
  return queryOptions({
    queryKey: pageKeys.list(storeId, params),
    queryFn: () => pagesApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function usePages(storeId: string, params: PageListParams) {
  return useQuery(pageListQueryOptions(storeId, params));
}
